import React from 'react';
import { Provider } from 'react-redux';
import Auth from '../Auth';

const Root = ({ store }) => (
  <Provider store={store}>
    <Auth />
  </Provider>
);

export default Root;
